<div [attr.data-qa]="qaTag"
     class="modal-dialog">
    <h2 [attr.data-qa]="qaTag + '-title'"
        class="modal-dialog-title">{{ 'SHOW_VERSION_DIALOG.TITLE' | translate }}</h2>
    <dl class="version-notes-list">
        @for (versionNote of versionNotes; track versionNote.labelTranslationKey) {
            <dt [attr.data-qa]="qaTag + '-note-label'"
                class="version-notes-label">{{ versionNote.labelTranslationKey | translate }}
            </dt>
            <dd [attr.data-qa]="qaTag + '-note-value'"
                class="version-notes-value">{{ versionNote.value }}
            </dd>
        }
    </dl>
    <div class="modal-dialog-action-text-buttons">
        <app-button (clicked)="copy()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.RED"
                    [buttonText]="'BUTTON.COPY' | translate"
                    [qaTag]="qaTag + '-copy-button'"/>
        <app-button (clicked)="close()"
                    [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                    [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                    [buttonText]="'BUTTON.CLOSE' | translate"
                    [qaTag]="qaTag + '-close-button'"/>
    </div>
</div>
